import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "../SignupPages/SignupCommon.css";

const IntakeFormPage8: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    const completeIntakeStep5 = localStorage.getItem("complete-intake-step5");
    if (completeIntakeStep5) {
      navigate("/complete-intake/step-6", { replace: true });
    } else {
      navigate("/complete-intake/step-5", { replace: true });
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "previous_medication_duration",
        JSON.stringify({
          key: "previous_medication_duration",
          value: selectedOption,
          id: 18026060,
        })
      );
    }
    navigate("/complete-intake/step-6b");
    localStorage.setItem("complete-intake-step6", "true");
  };

  useEffect(() => {
    const savedPreviousMedicationDuration = localStorage.getItem(
      "previous_medication_duration"
    );

    if (savedPreviousMedicationDuration) {
      const parsedPreviousMedicationDuration = JSON.parse(
        savedPreviousMedicationDuration
      );
      setSelectedOption(parsedPreviousMedicationDuration.value);
    }
  }, []);

  const options = [
    "I’ve never tried dieting or exercise",
    "Less than 6 months",
    "6-12 months",
    "Several years",
    "My whole life",
  ];

  const step = 6;

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={60} step={step} />
        <div className="signup-content">
          <p className="signup-intro">
            How long have you been trying to get to a healthier weight?
          </p>
          <div className="options">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={!selectedOption}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage8;
